import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMiscInvoiceHistoryDetailTable extends Layout {
    sourceMBDetailHist: DataSource;
    tableMiscInvoiceHistoryDetail: Table;
}
